<script setup>
import { ref } from 'vue';

const props = defineProps({
    titulo: {
        type: String,
        required: true
    },
    obrigatorio: {
        type: Boolean,
        default: false
    },
    help: {
        type: String,
    }
})

const ajudaAberta = ref(false);
</script>

<template>
    <div class="flex flex-row justify-content-between">
        <p class="text-xs md:text-sm font-medium mx-0 my-1 text-900" style="line-height: 20px;">
            {{ titulo }}
            <span class="text-red-400 text-xs" v-if="props.obrigatorio">*</span>
        </p>

        <p v-if="help" v-tooltip.left="help" style="line-height: 16px;"
            class="hidden md:flex text-xs flex-row gap-1 mx-0 my-1 align-items-center select-none text-400 hover:text-500">
            <span class="material-symbols-rounded text-sm">help</span>
            <span class="text-xs font-medium">Ajude-me</span>
        </p>

        <button v-if="help" type="button" @click="ajudaAberta = true"
            class="flex md:hidden flex-row gap-1 align-items-center p-0 my-1 border-none bg-transparent cursor-pointer select-none text-400"
            style="line-height: 16px; font-family: inherit;">
            <span class="material-symbols-rounded text-sm">help</span>
            <span class="text-xs font-medium">Ajude-me</span>
        </button>

        <Dialog v-if="help" v-model:visible="ajudaAberta" modal dismissableMask :draggable="false"
            :style="{ width: 'calc(100vw - 2rem)', maxWidth: '24rem' }">
            <template #header>
                <div class="flex flex-row align-items-center gap-2">
                    <span class="material-symbols-rounded text-lg text-500">help</span>
                    <span class="text-sm font-semibold text-900">{{ titulo }}</span>
                </div>
            </template>

            <p class="text-sm font-normal text-600 m-0" style="line-height: 1.5; letter-spacing: -0.01em;">
                {{ help }}
            </p>
        </Dialog>
    </div>
</template>
